<template>
  <div>
    <div class="bg"></div>
    <div class="content1 home-page">
      <div class="list">
        <img :src="Img1" alt="" />
      </div>
    </div>
    <div class="content2 home-page">
      <div class="list">
        <img :src="Img2" alt="" />
      </div>
    </div>
    <div class="content3 home-page">
      <div class="list">
        <img :src="Img3" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import Img1 from '@/assets/special_2.png'
import Img2 from '@/assets/special_3.png'
import Img3 from '@/assets/special_4.png'

export default {
  name: 'Content0',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: 'content0'
    }
  },
  data() {
    return {
      Img1,
      Img2,
      Img3,
      props: {}
    }
  },
  mounted() {
    // 初始化props
    this.props = { ...this.$props }
    delete this.props.dataSource
    delete this.props.isMobile
  }
}
</script>

<style scoped>
.content0-wrapper {
  width: 100%;
  overflow: hidden;
}

.content0-content {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 20px;
}

.bg {
  width: 100%;
  height: 440px;
  background: url(@/assets/special_1.png) no-repeat center center / 100% 100%;
}

.content1, .content2, .content3 {
  max-width: 1200px;
  margin: 0 auto;
  padding: 90px 20px 40px;
  text-align: center;
  position: relative;
  z-index: 1;
}

.content1 .list img,
.content2 .list img,
.content3 .list img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.content1 .list img:hover,
.content2 .list img:hover,
.content3 .list img:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
}

.copyright-wrapper {
  margin-top: 60px;
  padding: 20px;
  background-color: #333;
}

.copyright {
  text-align: center;
  color: #fff;
  font-size: 14px;
}

.copyright a {
  color: #fff;
  text-decoration: none;
}

.copyright a:hover {
  text-decoration: underline;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .content1, .content2, .content3 {
    padding: 20px 10px;
  }
}
</style>